<template>
  <span>
    <select v-if="displayType === 'form'" :disabled="readOnlyProp" name="" class="form-control" v-bind:value="modelValue" v-on:change="onChange($event.target.value)">
      <slot></slot>
      <option v-for="state in stateList" :value="state.state" :selected="state.state == defaultState">
        {{state.descState}}
      </option>
    </select>
    <span v-if="displayType === 'label'">{{stateLabel}}</span>
  </span>
</template>

<script>
  import CommonDataService from '../endpoints/CommonDataService'
  export default {
    emits: ['update:modelValue','change'],
    name: 'state-input',

    props: {
      displayType: '',
      modelValue: { default: null },
      readOnlyProp: Boolean
    },
    data () {
      return {
        stateList: []
      }
    },
    computed: {
      defaultState () {
        return this.modelValue
      },
      stateLabel: function () {
        if (this.stateList && this.stateList.length > 0) {
          let state = this.stateList.find((el) => el.state === this.modelValue)
          if (state) return state.descState
        }

        return ''
      }
    },
    methods: {
      loadStateList: function () {
        let self = this
        if (sessionStorage.stateList && sessionStorage.stateList.length > 0) {
          self.stateList = JSON.parse(sessionStorage.stateList)
          return
        }
        CommonDataService.loadStateList()
          .then(response => {
            self.stateList = response.data
            sessionStorage.stateList = JSON.stringify(self.stateList)
          })
          .catch(error => {
            self.error = error.message
          })
      },
      onChange (value) {
        this.$emit('update:modelValue', value)
        this.$emit('change', value)
      }
    },
    created () {
      this.loadStateList()
    }
  }
</script>
